import React from "react";

const TableCheckbox = ({ value, isChecked, onClick }) => {
  return (
    <input
      type="checkbox"
      value={value}
      className="table-check"
      checked={isChecked}
      onClick={onClick}
    />
  );
};

export default TableCheckbox;
